import React, { useImperativeHandle,useCallback, forwardRef } from 'react'
import { Modal,Header } from 'semantic-ui-react'

const CustomPopup = forwardRef(({actions,actionClass,description,header,className='',content=true,closeIcon,onClose},ref) => {
  const [open, setOpen] = React.useState(false)

  useImperativeHandle(ref, () => ({
    openPopup,
    closePopup
    
  }));
const openPopup=useCallback(()=>(setOpen(true)),[])

const closePopup=useCallback(()=>(setOpen(false)),[])

  return (
    <Modal className={className} onClose={onClose} closeIcon={closeIcon} open={open} >
      {header && <Header>{header}</Header>}
      {content && <Modal.Content>
        {
          description && <Modal.Description>
            {description}
        </Modal.Description>
      }
      </Modal.Content>
}
      {
        actions && <Modal.Actions className={actionClass}>
        {actions}
      </Modal.Actions>
}
    </Modal>

  )
})

export default CustomPopup